/** Versione semver del pacchetto client — aggiornare ad ogni release web/PWA. */
export const CURRENT_CLIENT_VERSION = '1.7.5'
